(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('PaperError', PaperError);

    PaperError.$inject = ['$resource', 'DateUtils'];

    function PaperError ($resource, DateUtils) {
        var resourceUrl =  'api/paper-errors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.settleDate = DateUtils.convertLocalDateFromServer(data.settleDate);
                        data.transDate = DateUtils.convertLocalDateFromServer(data.transDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.settleDate = DateUtils.convertLocalDateToServer(copy.settleDate);
                    copy.transDate = DateUtils.convertLocalDateToServer(copy.transDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.settleDate = DateUtils.convertLocalDateToServer(copy.settleDate);
                    copy.transDate = DateUtils.convertLocalDateToServer(copy.transDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
